module.exports = __webpack_public_path__ + "static/media/bg.76428889.jpg";